import React, { Component } from 'react';
import { Button } from 'antd';
import PropTypes from 'prop-types';

class ButtonComponent extends Component {
  render() {
    const { type, children, className, loading, disabled, onClick } = this.props;

    return (
      <Button
        type={type}
        loading={loading}
        disabled={disabled}
        onClick={onClick}
        style={{
          paddingTop: '.4rem',
          height: 'auto',
          paddingBottom: '.4rem'
        }}
        className={className}
      >
        {children}
      </Button>
    );
  }
}

ButtonComponent.propTypes = {
  type: PropTypes.oneOf(['default', 'primary']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func
};

ButtonComponent.defaultProps = {
  type: 'default',
  loading: false,
  disabled: false,
  className: '',
  onClick: null
};

export default ButtonComponent;
